import { fetchAccountService } from '@/services/account'

const SG_TOKEN_PATH = '/api/oauth/v1/vendor/token/access-token'

export const getSgToken = async (appId: string, authKey: string) => {
  try {
    const { data, ok, status } = await fetchAccountService<unknown>(
      `${SG_TOKEN_PATH}?clientId=${appId}&enableRefreshToken=true`,
      {
        headers: {
          authKey,
          'Content-Type': 'application/json',
        },
        method: 'GET',
      },
    )

    if (!ok || data === undefined) {
      throw new Error(`HTTP error! status: ${status}`)
    }

    return data
  } catch (error) {
    console.error('Failed to get SG token:', error)
    throw error
  }
}
